import { AnnotationVariable } from "../contexts";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if an object is an AnnotationVariable.
 *
 * @param obj - The object to check
 * @returns True if the object is an AnnotationVariable, false otherwise
 */
export const isAnnotationVariable = (obj: unknown): obj is AnnotationVariable => {
  if (!isObjectRecord(obj)) return false;

  if (typeof obj.value !== "string") return false;
  if (typeof obj.oid !== "string") return false;
  if (typeof obj.name !== "string") return false;
  if (typeof obj.dataType !== "string") return false;
  if (typeof obj.length !== "number") return false;
  if (typeof obj.description !== "string") return false;
  if (typeof obj.dataset !== "string") return false;
  if (!["number", "string", "undefined"].includes(typeof obj.codeList)) return false;

  return true;
};
